import {RecordSourceInspector} from 'relay-runtime'
import components from './components'
import environment, {setGlobalRelayWaitForIt} from './environment'
import hotwire from './hotwire'
import stimulus from './packs/stimulus'
import utils from './utils'

function getInspector() {
  /* eslint-disable no-underscore-dangle */
  return new RecordSourceInspector(environment._store._recordSource)
}

export default {
  components,
  utils,
  hotwire,
  stimulus,

  relay: {
    setGlobalRelayWaitForIt,
    environment,
    getInspector,
  },
}
